
import React from 'react';
import { Link } from 'react-router-dom';
import { Github, Globe } from 'lucide-react';

interface ProjectCardProps {
  title: string;
  description: string;
  tags: string[];
  image: string;
  github: string;
  demo: string;
}

const ProjectCard: React.FC<ProjectCardProps> = ({
  title,
  description,
  tags,
  image,
  github,
  demo,
}) => {
  return (
    <div className="bg-gray-800 rounded-lg p-6 shadow-md hover:bg-gray-700 transition group transform hover:-translate-y-1 duration-200 h-full flex flex-col">
      <Link to={demo} className="block flex-1">
        <div className="overflow-hidden rounded-lg mb-4">
          <img
            src={image}
            alt={title}
            className="rounded-lg mb-4 w-full h-36 object-cover transform group-hover:scale-105 transition duration-300"
          />
        </div>
        <h3 className="text-xl font-bold text-yellow-300 mb-2 group-hover:text-yellow-200">
          {title}
        </h3>
        <p className="text-gray-300 mb-4 line-clamp-3">{description}</p>
        <div className="flex flex-wrap gap-2 mb-4">
          {tags.map((tag, i) => (
            <span
              key={i}
              className="bg-yellow-300 text-black text-xs font-medium px-2 py-1 rounded"
            >
              #{tag}
            </span>
          ))}
        </div>
      </Link>
      <div className="flex justify-between items-center mt-auto pt-4 border-t border-gray-700">
        <a
          href={github}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-yellow-300 hover:text-yellow-200 transition"
          onClick={(e) => e.stopPropagation()}
        >
          <Github className="w-5 h-5" />
          GitHub
        </a>
        <Link
          to={demo}
          className="flex items-center gap-2 text-yellow-300 hover:text-yellow-200 transition"
        >
          <Globe className="w-5 h-5" />
          View Project
        </Link>
      </div>
    </div>
  );
};

export default ProjectCard;
